const REASON_KEYS = {
  COUPON_STATUS: 'payment.coupon.nonApplicableReason.status',
  TARGET_NOT_APPLICABLE: 'payment.coupon.nonApplicableReason.target',
  MINIMUM_PAYMENT: 'payment.coupon.nonApplicableReason.minimumPayment',
} as const

/** Missing/unknown server reasons are not evidence for a causal explanation. */
export function couponNonApplicableReasonKey(reason: string | null | undefined): string | null {
  return reason && Object.prototype.hasOwnProperty.call(REASON_KEYS, reason)
    ? REASON_KEYS[reason as keyof typeof REASON_KEYS]
    : null
}
